export default function ajax(arg){ 
    let ajaxData = { 
      type: (arg.type || "GET").toUpperCase(), 
      url: arg.url || "", 
      async: arg.async || "true", 
      data: arg.data || null, 
      dataType: arg.dataType || "json", 
      contentType: arg.contentType || "application/x-www-form-urlencoded", 
      beforeSend: arg.beforeSend || function(){}, 
      success: arg.success || function(){}, 
      error: arg.error || function(){} 
    } 
  
    ajaxData.beforeSend() 
    let xhr = createxmlHttpRequest();  
    xhr.responseType=ajaxData.dataType; 
  
    xhr.open(ajaxData.type,ajaxData.url,ajaxData.async);  
    xhr.setRequestHeader("Content-Type",ajaxData.contentType);  
    xhr.setRequestHeader("Accept",'application/json, text/plain, */*');  
    xhr.send(convertData(ajaxData.data));  
  
    xhr.onreadystatechange = function() {  
      if (xhr.readyState == 4) {  
        if(xhr.status == 200){ 
          ajaxData.success(xhr.response) 
        }else{ 
          ajaxData.error() 
        }  
      } 
    }  
  } 
  
  function createxmlHttpRequest() {  
    if (window.ActiveXObject) {  
      return new ActiveXObject("Microsoft.XMLHTTP");  
    } else if (window.XMLHttpRequest) {  
      return new XMLHttpRequest();  
    }  
  } 
    
  function convertData(data){ 
    if( typeof data === 'object' ){ 
      let convertResult = "" ;  
      for(let c in data){  
        convertResult+= c + "=" + data[c] + "&";  
      }  
      convertResult=convertResult.substring(0,convertResult.length-1) 
      return convertResult; 
    }else{ 
      return data; 
    } 
  }
